import React from 'react';
import type { ParcoursIndexItem } from '../../types/parcours';

interface Props {
  badge?: string;
  title: string;
  subtitle?: string;
  heroImageUrl?: string;
  companyLogoUrl?: string;
}

export default function LandingHero({ badge, title, subtitle, heroImageUrl, companyLogoUrl }: Props) {
  return (
    <section className="relative overflow-hidden">
      {/* Background image ou gradient fallback */}
      {heroImageUrl ? (
        <>
          <div className="absolute inset-0">
            <img
              src={heroImageUrl}
              alt=""
              className="w-full h-full object-cover"
              loading="eager"
              decoding="async"
            />
            <div className="absolute inset-0 bg-neutral-900/55" />
          </div>
          <div className="relative z-10 container-custom py-24 md:py-32">
            <HeroContent badge={badge} title={title} subtitle={subtitle} companyLogoUrl={companyLogoUrl} dark />
          </div>
        </>
      ) : (
        <div className="bg-gradient-to-br from-[#fdf2f8] via-white to-[#fef6ee]">
          <div className="container-custom py-20 md:py-28">
            <HeroContent badge={badge} title={title} subtitle={subtitle} companyLogoUrl={companyLogoUrl} dark={false} />
          </div>
        </div>
      )}
    </section>
  );
}

function HeroContent({
  badge,
  title,
  subtitle,
  companyLogoUrl,
  dark,
}: {
  badge?: string;
  title: string;
  subtitle?: string;
  companyLogoUrl?: string;
  dark: boolean;
}) {
  const textBase = dark ? 'text-white' : 'text-neutral-900';
  const textMuted = dark ? 'text-white/80' : 'text-neutral-600';
  const badgeBg = dark ? 'bg-white/15 text-white border border-white/20' : 'bg-[#d03484]/10 text-[#d03484]';

  return (
    <div className="max-w-3xl">
      {companyLogoUrl && (
        <img
          src={companyLogoUrl}
          alt={title}
          className={`h-12 w-auto mb-6 object-contain ${dark ? 'brightness-0 invert' : ''}`}
          loading="eager"
          decoding="async"
        />
      )}
      {badge && (
        <span className={`inline-block text-xs font-semibold uppercase tracking-widest rounded-full px-3 py-1 mb-4 ${badgeBg}`}>
          {badge}
        </span>
      )}
      <h1 className={`text-4xl md:text-5xl font-bold leading-tight mb-4 ${dark ? textBase : 'bg-gradient-to-r from-[#d03484] to-[#d47254] bg-clip-text text-transparent'}`}>
        {title}
      </h1>
      {subtitle && (
        <p className={`text-lg md:text-xl leading-relaxed ${textMuted}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
